import { AGENTPORTAL_URL_BASE } from './settings';

const generateInvoiceLink = (invoice: any) => {
  return `${AGENTPORTAL_URL_BASE}/insured/${invoice.accountNumber}?invoicePid=${invoice.id}&invoiceToken=${invoice.transactionId}`;
};

export {
  generateInvoiceLink
};
